import { classNamesOrEmpty } from "../../style/common";

export type CardVariantImageClickOverlayProps = {
    onLeftClick: () => void,
    onRightClick: () => void,
    className?: string | undefined,
    srText: string
}

export function CardVariantImageClickOverlay(props: CardVariantImageClickOverlayProps) {
    return (
        <a
            onClick={props.onLeftClick}
            onContextMenu={(event) => {
                if (props.onRightClick) {
                    event.preventDefault();
                    props.onRightClick();
                }
            }}
            className={`absolute top-0 bottom-0 left-0 right-0 cursor-pointer ${classNamesOrEmpty(props.className)}`}>
            <span className="sr-only">{props.srText}</span>
        </a>
    )
}